import React, { Component } from "react";
import Message from "./Message";
import "./Messages.css";
import DateSeparator from "./DateSeparator";
import moment from "moment-timezone";

export default class Messages extends Component {
  constructor(props) {
    super(props);
    this.container = null;
    this.autoScroll = true;
    this.lastScrollTop = 0;
  }

  componentDidMount() {
    this.container = document.querySelector("#messages");
    this.scrollDown();
    this.container.addEventListener("scroll", () => {
      // scroll up
      if (this.checkScrolledUp()) {
        this.autoScroll = false;
      }
      // scroll reaches bottom
      else if (this.checkScrollReachesBottom()) {
        this.autoScroll = true;
      }
      this.lastScrollTop = this.container.scrollTop;
    });
  }

  componentDidUpdate() {
    this.scrollDown();
  }

  checkScrolledUp() {
    return this.container.scrollTop < this.lastScrollTop;
  }

  checkScrollReachesBottom() {
    let bottomPoint = this.container.scrollHeight - 1000;
    return this.container.scrollTop > bottomPoint;
  }

  scrollDown() {
    if (this.autoScroll) {
      this.container.scrollTop = this.container.scrollHeight;
    }
  }

  render() {
    let lastDate = null;
    let currentDate = null;
    let separator = "";

    const messages = this.props.messages.map((message, i) => {
      currentDate = moment(message.envio, "DD/MM/YYYY HH:mm:ss")
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY");

      // message from logged user?
      let own = false;
      if (this.props.client) {
        own =
          this.props.client.user_id === message.user_id &&
          this.props.client.categoria === message.categoria;
      }

      // Add date separator?
      if (currentDate !== lastDate) {
        separator = <DateSeparator key={"datsep" + i} date={currentDate} />;
      } else {
        separator = "";
      }

      lastDate = currentDate;

      return (
        <div key={"meswrap" + i}>
          {separator}
          <Message key={"mes" + message.id} own={own} message={message} />
        </div>
      );
    });

    return <div id="messages"> {messages} </div>;
  }
}



// WEBPACK FOOTER //
// ./src/chat/Messages.js